var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentageSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Percentage Sign",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 585",
    d: "M5.465 15.655a.879.879 0 0 1-.588.486.914.914 0 0 1-.652-.113.944.944 0 0 1-.425-.528.883.883 0 0 1 .119-.753l5.7-10.075a.908.908 0 0 1 .588-.494.884.884 0 0 1 .652.105.91.91 0 0 1 .413.526.937.937 0 0 1-.111.753zm-2-4.406a2.6 2.6 0 0 1-2.147-.949 3.952 3.952 0 0 1-.763-2.549 3.89 3.89 0 0 1 .771-2.543 2.613 2.613 0 0 1 2.137-.939 2.6 2.6 0 0 1 2.137.947 3.9 3.9 0 0 1 .771 2.535A3.924 3.924 0 0 1 5.6 10.3a2.6 2.6 0 0 1-2.137.949zm0-1.555a.8.8 0 0 0 .723-.462A3.143 3.143 0 0 0 4.45 7.75a3.039 3.039 0 0 0-.262-1.466.819.819 0 0 0-1.454-.008A3.115 3.115 0 0 0 2.48 7.75a3.215 3.215 0 0 0 .254 1.5.8.8 0 0 0 .729.444zm8.184 6.349A2.6 2.6 0 0 1 9.5 15.1a3.979 3.979 0 0 1-.763-2.567 3.857 3.857 0 0 1 .773-2.539 2.623 2.623 0 0 1 2.137-.931 2.613 2.613 0 0 1 2.137.937 3.863 3.863 0 0 1 .771 2.527 3.979 3.979 0 0 1-.763 2.567 2.6 2.6 0 0 1-2.145.949zm0-1.571a.8.8 0 0 0 .731-.454 3.221 3.221 0 0 0 .254-1.49 3.046 3.046 0 0 0-.262-1.458.816.816 0 0 0-1.454-.016 3.115 3.115 0 0 0-.254 1.474 3.215 3.215 0 0 0 .254 1.5.8.8 0 0 0 .729.444z",
    transform: "translate(-.555 -4.158)",
    style: {
      fill: "#5c5c5c"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageSign);
export default __webpack_public_path__ + "static/media/Percentage Sign.59eaa406.svg";
export { ForwardRef as ReactComponent };